export default "__VITE_ASSET__f9a1fa10__"